export const READ_MORE_BUTTON_ID = 'read-more-button';
export const READ_MORE_CONTENT_ID = 'read-more-content';
